export default __webpack_public_path__ + "static/hero_bk_v2-01f68be82d23a1dbf1e4ca9ba762be87.png";